import { render } from "./setMealOnlyLookModel.vue?vue&type=template&id=09e81f6e"
import script from "./setMealOnlyLookModel.vue?vue&type=script&lang=js"
export * from "./setMealOnlyLookModel.vue?vue&type=script&lang=js"

import "./setMealOnlyLookModel.vue?vue&type=style&index=0&id=09e81f6e&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__